import * as React from 'react';
import { AppSourceSitemap } from '../components/sitemap';
const { connect } = require('react-redux');
export const mapStateToProps = (state, ownProps)=>{
    return {
        appsDatamap: state.apps.dataMap,
        servicesDatamap: state.services.dataMap
    };
};
export const SitemapContainer = connect(mapStateToProps)(AppSourceSitemap);
export default SitemapContainer;
